import CompareIcon from "shared/assets/images/user.png";

export async function srcToBase64(src: string = CompareIcon): Promise<any> {
  if (!src) {
    src = CompareIcon;
  }
  const response = await fetch(src);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("loadend", () => resolve(reader.result));
    reader.addEventListener("error", reject);
    reader.readAsDataURL(blob);
  });
}
